export { default as HomeHero } from "./Hero";
export { default as HomeJuxtapose } from "./Juxtapose";
export { default as HomeSkills } from "./Skills";
export { default as HomeApproach } from "./Approach";
export { default as HomeProcess } from "./Process";
export { default as HomeWork } from "./Work";
export { default as HomeMap } from "./Map";


// WEBPACK FOOTER //
// ./src/components/home/index.js